import { GROUPS } from "../data/groups";

export function groupNames(subgroupId: string): { group: string; subgroup: string } {
  for (const g of GROUPS) {
    const s = g.subgroups.find((x) => x.id === subgroupId);
    if (s) return { group: g.nameTh, subgroup: s.nameTh };
  }
  return { group: "", subgroup: "" };
}

export { countryName } from "../geo/place";

export const fmt = (n: number) => n.toLocaleString("th-TH");

/** มดงานและผึ้งงานไม่ออกลูกเอง คะแนนของพวกมันคือน้องที่ช่วยเลี้ยงในรัง */
export function offspringLabel(flags: readonly string[]): string {
  return flags.includes("role_worker") ? "น้องที่ช่วยเลี้ยง" : "ลูกหลาน";
}
